import { buildPersonalizationSections } from './buildPersonalizationSections';
import { MAX_PERSONALIZATION_COPY_LENGTH } from './constants';

export function extractPersonalizationPayload({ productConfig, formatMessage }) {
  const sectionsWithKeys = buildPersonalizationSections(productConfig);

  const sections = sectionsWithKeys
    .map(({ section, keys }) => ({
      section,
      items: keys
        .map((key) => ({ key, copy: formatMessage({ id: key }) }))
        .filter((item) => item.copy.length <= MAX_PERSONALIZATION_COPY_LENGTH),
    }))
    .filter(({ items }) => items.length > 0);

  return {
    sections,
    requestedKeys: new Set(sections.flatMap((section) => section.items.map((item) => item.key))),
  };
}
